// Get Transaction List Constants
export const GET_TRANSACTION_LIST_REQUEST = 'GET_TRANSACTION_LIST_REQUEST';
export const GET_TRANSACTION_LIST_SUCCESS = 'GET_TRANSACTION_LIST_SUCCESS';
export const GET_TRANSACTION_LIST_FAILURE = 'GET_TRANSACTION_LIST_FAILURE';